import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=2acc8998&scoped=true&"
import script from "./tree.vue?vue&type=script&lang=js&"
export * from "./tree.vue?vue&type=script&lang=js&"
import style0 from "./tree.vue?vue&type=style&index=0&id=2acc8998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acc8998",
  null
  
)

export default component.exports